import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { iif, of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../shared/enums/HttpStatusCodes';
import { GESTION_TICKETS_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errroTicketsMesSeleccion,
    errroVentasMes,
    errroVentasMesSeleccion,
    reloadTicketsMesSeleccion,
    reloadVentasMesSeleccion,
    successTicketsMesSeleccion,
    successVentasMes,
    successVentasMesSeleccion,
    ticketsMesSeleccion,
    ventasMes,
    ventasMesSeleccion,
} from '../actions';
import { AppState } from '../app-reducers';

@Injectable()
export class VentasTicketsEffets {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
        , private store: Store<AppState>
    ) { }

    /**
     * * Obtiene configuraciones del mes para ventas y tickets
     */
    public ventasMes$ = createEffect(
        () => this.actions$.pipe(
            ofType(ventasMes),
            switchMap(
                () => this.httpS.executeRequestByUser(GESTION_TICKETS_ENDPOINTS.post_obtiene_ventas_mes_historico_tendero,
                    null, this.httpS.getAzureCAUrl(AZURE_CA_URLS.GESTION_TICKETS))
                    .pipe(
                        map(resp => successVentasMes(resp)),
                        catchError((err: Error) => of(errroVentasMes({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Obtiene las ventas y sus montos por mes seleccionado
     */
    public ventasMesSeleccion$ = createEffect(
        () => this.actions$.pipe(
            ofType(ventasMesSeleccion),
            switchMap(actions => this.store.select('ventasTickestSeleccion')
                .pipe(
                    first(),
                    map(resp => ({
                        isSales: resp.Ventas.MontoVentasDia.filter(x => x.Anio === Number(actions.FechaMes.split('-')[0]) && x.Mes === Number(actions.FechaMes.split('-')[1])).length > 0,
                        MontoVentasDia: resp.Ventas.MontoVentasDia,
                        MontoVentasSemana: resp.Ventas.MontoVentasSemana,
                        ...actions,
                    })),
                )
            ),
            switchMap(
                actions => iif(
                    () => actions.isSales && !actions.MesActual,
                    of({
                        success: true,
                        status: 'resp/sended-file',
                        message: 'Archivo enviado exitosamente',
                        ...actions
                    })
                        .pipe(
                            map(resp => reloadVentasMesSeleccion(resp))
                        ),
                    this.httpS.executeRequestByUser(GESTION_TICKETS_ENDPOINTS.post_obtiene_ventas_dias_sem_historico_tendero,
                        { FechaMes: actions.FechaMes, IsTicket: actions.IsTicket }, this.httpS.getAzureCAUrl(AZURE_CA_URLS.GESTION_TICKETS))
                        .pipe(
                            map(resp => successVentasMesSeleccion(resp)),
                            catchError((err: Error) => of(errroVentasMesSeleccion({ payload: err })))
                        )
                )
            )
        )
    );

    /**
     * * Obtiene los tickets de preventa por mes seleccionado
     */
    public ticketsMesSeleccion$ = createEffect(
        () => this.actions$.pipe(
            ofType(ticketsMesSeleccion),
            switchMap(actions => this.store.select('ventasTickestSeleccion')
                .pipe(
                    first(),
                    map(resp => ({
                        isPreventa: resp.Preventa.TicketsPreventa.filter(x => x.Anio === Number(actions.InicioMes.split('-')[0]) && x.Mes === Number(actions.InicioMes.split('-')[1])).length > 0,
                        TicketsPreventa: resp.Preventa.TicketsPreventa,
                        ...actions
                    })),
                )
            ),
            switchMap(
                actions => iif(
                    () => actions.isPreventa && !actions.MesActual,
                    of({
                        success: true,
                        status: 'resp/sended-file',
                        message: 'Archivo enviado exitosamente',
                        ...actions
                    })
                        .pipe(
                            map(resp => reloadTicketsMesSeleccion(resp))
                        ),
                    this.httpS.executeRequestByUser(actions.MesActual
                        ? GESTION_TICKETS_ENDPOINTS.post_obtiene_ventas_new_tickets_tendero
                        : GESTION_TICKETS_ENDPOINTS.post_obtiene_ventas_historico_tickets_tendero,
                        { InicioMes: actions.InicioMes, IsTicketPreventa: actions.IsTicketPreventa }, this.httpS.getAzureCAUrl(AZURE_CA_URLS.GESTION_TICKETS))
                        .pipe(
                            map(resp => successTicketsMesSeleccion(resp)),
                            catchError((err: Error) => of(errroTicketsMesSeleccion({ payload: err })))
                        )
                )
            )
        )
    );
}
